const yearFields = {
  actualYearReport: '',
};

export const yearFieldsKeys = Object.keys(yearFields);

export const defaultState = {
  membership: {
    individualMembers: yearFields,
    individualMembersF: yearFields,
    individualMembersM: yearFields,
    nationalYoungCrewMembers: yearFields,
    nationalYoungCrewMembersF: yearFields,
    nationalYoungCrewMembersM: yearFields,
    corporateMembers: yearFields,
    activeVolunteers: yearFields,
    membershipNotes: { notes: '' },
  },
  events: {
    eventsTotalParticipants: yearFields,
    eventsNumberNonReg: yearFields,
    eventsNotes: { notes: '' },
  },
  education: {
    regDiplomas: yearFields,
    educationNotes: { notes: '' },
  },
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
